// ========================================================================
// src/components/common/Notification.js
// Version: 1.0.0 - Standard Notification component
// ========================================================================
import React from 'react';
import { AlertTriangle, CheckCircle, Info } from 'lucide-react'; // Added Info icon
import { useNotifier } from '../../hooks/useNotifier'; // Adjusted path

const NotificationComponent = () => { // Renamed to avoid conflict if 'Notification' is used elsewhere
  const { notification, hideNotification } = useNotifier();

  if (!notification) return null;

  let bgColor = 'bg-blue-500'; // Default for info
  let Icon = Info;

  if (notification.type === 'success') {
    bgColor = 'bg-green-500';
    Icon = CheckCircle;
  } else if (notification.type === 'error') {
    bgColor = 'bg-red-500';
    Icon = AlertTriangle;
  }

  return (
    <div
      className={`fixed top-20 right-5 p-4 rounded-md shadow-lg text-white ${bgColor} z-50 flex items-center transition-all duration-300 ease-in-out transform animate-slideIn`}
      role="alert"
    >
      <Icon size={24} className="mr-3 flex-shrink-0" />
      <span className="flex-grow">{notification.message}</span>
      <button
        onClick={hideNotification}
        className="ml-4 text-xl font-bold hover:text-gray-200 transition-colors"
        aria-label="Close notification"
      >
        &times;
      </button>
      <style jsx global>{`
        @keyframes slideInNotification { /* Renamed animation to be specific */
          from {
            opacity: 0;
            transform: translateX(100%);
          }
          to {
            opacity: 1;
            transform: translateX(0);
          }
        }
        .animate-slideIn { /* Ensure this class matches the animation name */
          animation: slideInNotification 0.3s forwards;
        }
      `}</style>
    </div>
  );
};
export default NotificationComponent;
